export const appTypeId = slug => ({
    'google-apps': '1',
    'custom': '2',
    'computer-login': '9',
    'slack': '48',
    'enterprise-password-manager': '78',
    'computer-protection-without-ad': '309',
})[slug];

export const isRadius = slug => [
    'radius',
    'cisco-asa',
    'check-point',
    'microsoft-routing-and-remote-access-rras',
    'cisco-meraki-radius',
    'wi-fi-captive-portal',
    'microsoft-radius-remote-desktop-gateway',
    'open-vpn',
    'dell-sonic-wall-radius',
    'citrix-net-scaler-radius',
    'v-mware-horizon-view',
    'cisco-meraki-client-vpn',
    'array-networks-radius',
    'sophos-firewall-xg-radius',
].includes(slug);



// WEBPACK FOOTER //
// ./src/portal/models/application-types.js